import { LitElement, html } from 'lit';
import styles from './studio-tooltip.css.mjs';

/**
 * <studio-tooltip>
 * Props:
 * - position: "top" | "bottom" | "left" | "right"
 * - text: string (fallback if no slot="content")
 * - background-color: string (CSS color)
 * - text-color: string (CSS color)
 * - size: "small" | "medium" | "large"
 */
export class StudioTooltip extends LitElement {
  static styles = styles;

  static properties = {
    position: { type: String, reflect: true },
    text: { type: String, reflect: true },
    backgroundColor: { type: String, attribute: 'background-color', reflect: true },
    textColor: { type: String, attribute: 'text-color', reflect: true },
    size: { type: String, reflect: true },
  };

  static validPositions = ['top','bottom','left','right'];
  static validSizes = ['small','medium','large'];

  constructor() {
    super();
    this.position = 'bottom';
    this.text = '';
    this.backgroundColor = '';
    this.textColor = '';
    this.size = 'medium';
  }

  updated(changed) {
    if (changed.has('backgroundColor')) {
      if (this.backgroundColor) this.style.setProperty('--tooltip-bg', this.backgroundColor);
      else this.style.removeProperty('--tooltip-bg');
    }
    if (changed.has('textColor')) {
      if (this.textColor) this.style.setProperty('--tooltip-color', this.textColor);
      else this.style.removeProperty('--tooltip-color');
    }
    if (changed.has('size')) this.#applySizeVars();
  }

  #applySizeVars = () => {
    const map = {
      small:  { w: '120px', h: '28px', fs: '12px', lh: '16px', a: '6px'  },
      medium: { w: '160px', h: '32px', fs: '14px', lh: '20px', a: '8px'  },
      large:  { w: '200px', h: '40px', fs: '16px', lh: '24px', a: '10px' },
    };
    const m = map[this.size] || map.medium;
    this.style.setProperty('--tooltip-width', m.w);
    this.style.setProperty('--tooltip-min-height', m.h);
    this.style.setProperty('--font-size-b3', m.fs);
    this.style.setProperty('--line-height-b3', m.lh);
    this.style.setProperty('--arrow-size', m.a);
  };

  #tooltipId = 'tt-' + Math.random().toString(36).slice(2);

  render() {
    return html`
      <div class="trigger" aria-describedby=${this.#tooltipId}>
        <slot></slot>
        <div class="tooltip" id=${this.#tooltipId} role="tooltip" part="tooltip">
          <slot name="content">
            ${this.text ? html`<span class="text">${this.text}</span>` : ''}
          </slot>
        </div>
      </div>
    `;
  }
}

customElements.define('studio-tooltip', StudioTooltip);